<bm-core-file-viewer
	style="display: none"
	[webViewerPath]="webViewerLibPath"
	(webViewerInstantiated)="onWebViewerLoad($event)"
>
</bm-core-file-viewer>

<div #viewer [hidden]="true"></div>
